// VA Departments - Top 50 National Level VA Departments Directory

export const vaDepartments = [
  {
    id: 4001,
    title: 'Office of the Secretary of Veterans Affairs',
    category: 'VA Departments',
    director: 'Hon. Douglas A. Collins - Secretary',
    phone: '202-461-4800',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'department.va.gov',
    description: 'Top executive office overseeing all VA operations and services.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop'
  },
  {
    id: 4002,
    title: 'Office of the Deputy Secretary of Veterans Affairs',
    category: 'VA Departments',
    director: 'Deputy Secretary of Veterans Affairs',
    phone: '202-461-4800',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'department.va.gov',
    description: 'Second-in-command executive office supporting the VA Secretary.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4003,
    title: 'Veterans Health Administration (VHA)',
    category: 'VA Departments',
    director: 'Dr. John Bartrum - Under Secretary for Health',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/health',
    description: 'Largest integrated healthcare system providing comprehensive medical services to veterans.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4004,
    title: 'Veterans Benefits Administration (VBA)',
    category: 'VA Departments',
    director: 'Under Secretary for Benefits',
    phone: '202-461-9700',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'benefits.va.gov',
    description: 'Administers benefits including disability compensation, pensions, education, and home loans.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4005,
    title: 'National Cemetery Administration (NCA)',
    category: 'VA Departments',
    director: 'Under Secretary for Memorial Affairs',
    phone: '202-461-9700',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'cem.va.gov',
    description: 'Maintains national cemeteries and provides burial benefits for veterans.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4006,
    title: 'Office of Inspector General (VA OIG)',
    category: 'VA Departments',
    director: 'Cheryl L. Mason - Inspector General',
    phone: '800-488-8244',
    address: '801 I Street NW, Washington, DC 20001',
    website: 'va.gov/oig',
    description: 'Independent oversight conducting audits and investigations of VA programs.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4007,
    title: 'Board of Veterans\' Appeals (BVA)',
    category: 'VA Departments',
    director: 'Kenneth A. Arnold - Acting Chairman',
    phone: '800-923-8387',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'bva.va.gov',
    description: 'Reviews appeals of VA benefits decisions.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4008,
    title: 'Office of General Counsel',
    category: 'VA Departments',
    director: 'VA General Counsel',
    phone: '202-461-4900',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/ogc',
    description: 'Provides legal advice and representation for VA operations.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4009,
    title: 'Office of Accountability & Whistleblower Protection',
    category: 'VA Departments',
    director: 'Assistant Secretary for Accountability',
    phone: '202-461-4720',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/accountability',
    description: 'Protects whistleblowers and ensures VA employee accountability.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4010,
    title: 'Office of Information & Technology (OIT)',
    category: 'VA Departments',
    director: 'VA Chief Information Officer',
    phone: '202-461-6000',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'oit.va.gov',
    description: 'Manages VA technology infrastructure and digital services.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4011,
    title: 'Office of Acquisition, Logistics & Construction',
    category: 'VA Departments',
    director: 'Assistant Secretary for Acquisition',
    phone: '202-461-4000',
    address: '425 I Street NW, Washington, DC 20001',
    website: 'va.gov/oal',
    description: 'Oversees VA procurement, supply chain, and construction projects.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4012,
    title: 'Office of Human Resources & Administration',
    category: 'VA Departments',
    director: 'Assistant Secretary for HR & Administration',
    phone: '202-461-7800',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/ohrm',
    description: 'Manages VA workforce policies and employee services.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4013,
    title: 'Office of Operations, Security & Preparedness',
    category: 'VA Departments',
    director: 'Assistant Secretary for OSP',
    phone: '202-461-5134',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/osp',
    description: 'Ensures VA facility security and emergency preparedness.',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop'
  },
  {
    id: 4014,
    title: 'Office of Management',
    category: 'VA Departments',
    director: 'Assistant Secretary for Management / CFO',
    phone: '202-461-4000',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/ofm',
    description: 'Oversees VA budget, financial management, and performance improvement.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4015,
    title: 'Office of Mental Health & Suicide Prevention',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-4058',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'mentalhealth.va.gov',
    description: 'Leads VA mental health services and suicide prevention programs.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4016,
    title: 'Homeless Programs Office',
    category: 'VA Departments',
    director: 'Executive Director of Homeless Programs',
    phone: '877-424-3838',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/homeless',
    description: 'Coordinates national efforts to end veteran homelessness.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4017,
    title: 'Office of Rural Health',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-6750',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'ruralhealth.va.gov',
    description: 'Improves healthcare access for rural veterans.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4018,
    title: 'Office of Women Veterans',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-6193',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/womenvet',
    description: 'Advocates for and coordinates services for women veterans.',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop'
  },
  {
    id: 4019,
    title: 'Center for Minority Veterans',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-6191',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/centerforminorityveterans',
    description: 'Promotes equity in VA services for minority veterans.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4020,
    title: 'Center for Faith-Based & Neighborhood Partnerships',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-6608',
    address: '810 Vermont Ave NW, Washington, DC 20420',
    website: 'va.gov/partnerships',
    description: 'Collaborates with faith-based and community organizations.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4021,
    title: 'Office of Public & Intergovernmental Affairs',
    category: 'VA Departments',
    director: 'Assistant Secretary for Public Affairs',
    phone: '202-461-7600',
    address: '810 Vermont Ave NW, Washington DC',
    website: 'va.gov/opa',
    description: 'Manages VA communications and public information.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4022,
    title: 'Office of Congressional & Legislative Affairs',
    category: 'VA Departments',
    director: 'Assistant Secretary for Congressional Affairs',
    phone: '202-461-6900',
    address: '810 Vermont Ave NW, Washington DC',
    website: 'va.gov/oca',
    description: 'Serves as VA liaison to Congress.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4023,
    title: 'Office of Policy & Planning',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-4902',
    address: '810 Vermont Ave NW',
    website: 'va.gov/policy',
    description: 'Develops and coordinates VA policy initiatives.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4024,
    title: 'Office of Small & Disadvantaged Business Utilization',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-4300',
    address: '810 Vermont Ave NW',
    website: 'va.gov/osdbu',
    description: 'Promotes veteran-owned business contracting opportunities.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4025,
    title: 'Office of Enterprise Integration',
    category: 'VA Departments',
    director: 'Chief Strategy Officer',
    phone: '202-461-7100',
    address: '810 Vermont Ave NW',
    website: 'va.gov/oie',
    description: 'Coordinates VA strategic planning and integration.',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop'
  },
  {
    id: 4026,
    title: 'Electronic Health Record Modernization Integration Office',
    category: 'VA Departments',
    director: 'Program Executive Director',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'ehrm.va.gov',
    description: 'Manages VA electronic health record system modernization.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4027,
    title: 'Office of Community Care',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '877-881-7618',
    address: '810 Vermont Ave NW',
    website: 'va.gov/communitycare',
    description: 'Coordinates veteran care with non-VA providers.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4028,
    title: 'Office of Research & Development',
    category: 'VA Departments',
    director: 'Chief Research & Development Officer',
    phone: '202-443-5757',
    address: '810 Vermont Ave NW',
    website: 'research.va.gov',
    description: 'Conducts biomedical research for veteran health.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4029,
    title: 'Office of Healthcare Innovation & Learning',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/innovation',
    description: 'Drives healthcare innovation and staff development.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4030,
    title: 'Office of Patient Care Services',
    category: 'VA Departments',
    director: 'Chief Patient Care Services Officer',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/patientcare',
    description: 'Oversees clinical care standards and patient services.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4031,
    title: 'National Center for PTSD',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '802-296-6300',
    address: '215 North Main St, White River Junction, VT',
    website: 'ptsd.va.gov',
    description: 'World leader in PTSD research, education, and treatment.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4032,
    title: 'Office of Veterans Experience',
    category: 'VA Departments',
    director: 'Chief Veterans Experience Officer',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/ve',
    description: 'Improves veteran experience across all VA services.',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop'
  },
  {
    id: 4033,
    title: 'Office of Strategic Partnerships',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-6608',
    address: '810 Vermont Ave NW',
    website: 'va.gov/partnerships',
    description: 'Builds partnerships with external organizations.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4034,
    title: 'Office of Chief Financial Officer',
    category: 'VA Departments',
    director: 'Chief Financial Officer',
    phone: '202-461-4000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/ofm',
    description: 'Manages VA financial operations and reporting.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4035,
    title: 'Office of Chief Data Officer',
    category: 'VA Departments',
    director: 'Chief Data Officer',
    phone: '202-461-6000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/data',
    description: 'Oversees VA data governance and analytics.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4036,
    title: 'Office of Compliance & Ethics',
    category: 'VA Departments',
    director: 'Chief Ethics Officer',
    phone: '202-461-4720',
    address: '810 Vermont Ave NW',
    website: 'va.gov/ethics',
    description: 'Ensures VA compliance with ethical standards.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4037,
    title: 'Office of Healthcare Transformation',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/transformation',
    description: 'Leads VA healthcare system transformation initiatives.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4038,
    title: 'Office of Construction & Facilities Management',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-8000',
    address: '425 I Street NW, Washington DC',
    website: 'va.gov/cfm',
    description: 'Manages VA facility construction and maintenance.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4039,
    title: 'Office of Emergency Management',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-7440',
    address: '810 Vermont Ave NW',
    website: 'va.gov/oem',
    description: 'Coordinates VA emergency preparedness and response.',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop'
  },
  {
    id: 4040,
    title: 'Office of Digital Transformation',
    category: 'VA Departments',
    director: 'Chief Digital Transformation Officer',
    phone: '202-461-6000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/digital',
    description: 'Modernizes VA digital services and technology.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4041,
    title: 'Office of Privacy & Records Management',
    category: 'VA Departments',
    director: 'Chief Privacy Officer',
    phone: '202-461-6333',
    address: '810 Vermont Ave NW',
    website: 'va.gov/privacy',
    description: 'Protects veteran privacy and manages VA records.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4042,
    title: 'Office of Security & Law Enforcement',
    category: 'VA Departments',
    director: 'Chief of Police Services',
    phone: '202-461-5134',
    address: '810 Vermont Ave NW',
    website: 'va.gov/security',
    description: 'Ensures security at VA facilities nationwide.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4043,
    title: 'Office of Government Ethics',
    category: 'VA Departments',
    director: 'Ethics Program Officer',
    phone: '202-461-4720',
    address: '810 Vermont Ave NW',
    website: 'va.gov/ethics',
    description: 'Administers VA ethics program.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  },
  {
    id: 4044,
    title: 'Office of Equal Employment Opportunity',
    category: 'VA Departments',
    director: 'Assistant Secretary for EEO',
    phone: '202-461-4131',
    address: '810 Vermont Ave NW',
    website: 'va.gov/eeo',
    description: 'Promotes equal employment opportunity within VA.',
    image: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&h=600&fit=crop'
  },
  {
    id: 4045,
    title: 'Office of Diversity, Equity & Inclusion',
    category: 'VA Departments',
    director: 'Chief Diversity Officer',
    phone: '202-461-4131',
    address: '810 Vermont Ave NW',
    website: 'va.gov/diversity',
    description: 'Advances diversity, equity, and inclusion at VA.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop'
  },
  {
    id: 4046,
    title: 'Employee Education System',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '314-894-6600',
    address: '1 Jefferson Barracks Dr, St Louis, MO',
    website: 'ees.va.gov',
    description: 'Provides training and development for VA employees.',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop'
  },
  {
    id: 4047,
    title: 'Veterans Crisis Line Program Office',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '988',
    address: 'Canandaigua VA Medical Center, NY',
    website: 'veteranscrisisline.net',
    description: '24/7 crisis support for veterans and their families.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop'
  },
  {
    id: 4048,
    title: 'VA Innovation Ecosystem',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'innovation.va.gov',
    description: 'Fosters innovation across VA healthcare.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop'
  },
  {
    id: 4049,
    title: 'Office of Health Informatics',
    category: 'VA Departments',
    director: 'Chief Health Informatics Officer',
    phone: '202-461-6000',
    address: '810 Vermont Ave NW',
    website: 'va.gov/informatics',
    description: 'Manages VA health information systems.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop'
  },
  {
    id: 4050,
    title: 'National Center for Ethics in Health Care',
    category: 'VA Departments',
    director: 'Executive Director',
    phone: '202-461-7000',
    address: '810 Vermont Ave NW',
    website: 'ethics.va.gov',
    description: 'Integrates ethics into VA healthcare delivery.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&h=600&fit=crop'
  }
];
